<template>
  <div class="spinner-border" role="status" aria-hidden="true"></div>
  <p class="mt-3 mb-0">{{ mensaje }}</p>
</template>

<script setup>
const { mensaje } = defineProps({
  mensaje: { type: String, required: true },
});
</script>
